import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../constants';
import Button from './ui/button';
import ContactForm from './forms/ContactForm';

const EvidencePeopleFirstSection = () => {
  return (
    <section className="bg-gray-100 pt-12 sm:pt-16 md:pt-20 pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image with overlaid content box */}
        <div className="max-w-6xl mx-auto">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/market-sizing-new.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                Acquisition modelling<br />
                <strong className="text-[#db0058]">increases sales by 29%</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">Finance</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                It's often the case that models used to determine a brands/products target audience can tire and targetable volumes diminish. The need for regularly profiling and performance analysis on consumer data is necessary along with a modelling dataset that is sizable and accurate in breadth and depth. Frequently we are approached with this problem… How can we improve our Direct Mail or Email channel performance?
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Using our Resident UK consumer data single view of 51m adults and 400+ variables we can model existing customer data to create a flexible model of opportunity which can be dialled up or down to specific response, conversion, CPS or yr1/yr2 value targets.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                By increasing prospect opportunity and removing weaker performing consumer data falling below target, sales volumes increased by 29% within target CPS levels.
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <button
                  className="font-semibold rounded-full transition-colors duration-300 inline-flex items-center justify-center text-white py-2 px-6 text-sm min-h-[40px]"
                  type="button"
                  style={{ backgroundColor: 'rgb(219, 0, 88)' }}
                >
                  Find out more
                </button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/market-sizing-new.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle right */}
            <div className="absolute top-1/2 right-8 transform -translate-y-1/2 bg-white p-4 sm:p-5 md:p-6 shadow-lg w-4/5 max-w-2xl detaservinfo">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-3">
                Acquisition modelling<br />
                <strong className="text-[#db0058]">increases sales by 29%</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">Finance</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                It's often the case that models used to determine a brands/products target audience can tire and targetable volumes diminish. The need for regularly profiling and performance analysis on consumer data is necessary along with a modelling dataset that is sizable and accurate in breadth and<br />
                depth. Frequently we are approached with this problem…<br />
                How can we improve our Direct Mail or Email channel performance?
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Using our Resident UK consumer data single view of 51m adults and 400+ variables we can model existing customer data to create a flexible model of opportunity which can be dialled up or down to specific response, conversion, CPS or yr1/yr2 value targets.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2 sm:mb-3">
                By increasing prospect opportunity and removing weaker performing consumer data falling below target, sales volumes increased by 29% within target CPS levels.
              </p>
            </div>
          </div>
        </div>

        {/* Second Image Section with left-positioned text box */}
        <div className="max-w-6xl mx-auto mt-16 sm:mt-20 md:mt-24">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/iskey.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                Growth planning increases sales<br />
                <strong className="text-[#db0058]">by 86% at a 26% lower CPS</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">General insurance</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Due to a change in business requirement our clients objective shifted to driving growth aiming for a 25% sales increase over a 3mth period within a budgeted 10% CPS increase against target.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                We utilised our existing performance model exhausting all contactable individuals within a maximum CPS range, tracked against proven response and conversion rates. Whilst introducing new consumer data types for controlled testing and a contact strategy to optimise return. A detailed forecast was provided outlining opportunity levels against scaled degrees of risk.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                The plan exceeded all expectations with the new tests and contact optimisation driving a significant uplift. Average unique monthly contacts increased by 53%, the volume of sales increased by 86% and overall CPS reduced by 26%.
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <button
                  className="font-semibold rounded-full transition-colors duration-300 inline-flex items-center justify-center text-white py-2 px-6 text-sm min-h-[40px]"
                  type="button"
                  style={{ backgroundColor: 'rgb(219, 0, 88)' }}
                >
                  Find out more
                </button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/iskey.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle left */}
            <div className="absolute top-1/2 left-8 transform -translate-y-1/2 bg-white p-4 sm:p-5 md:p-6 shadow-lg w-4/5 max-w-2xl">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-3">
                Growth planning increases sales<br />
                <strong className="text-[#db0058]">by 86% at a 26% lower CPS</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">General insurance</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Due to a change in business requirement our clients objective shifted to driving growth aiming for a 25% sales increase over a 3mth period within a budgeted 10% CPS increase against target.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                We utilised our existing performance model exhausting all contactable individuals within a maximum CPS range, tracked against proven response and conversion rates. Whilst introducing new consumer data types for controlled testing and a contact strategy to optimise return. A detailed forecast was provided outlining opportunity levels against scaled degrees of risk.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2 sm:mb-3">
                The plan exceeded all expectations with the new tests and contact optimisation driving a significant uplift. Average unique monthly contacts increased by 53%, the volume of sales increased by 86% and overall CPS reduced by 26%.
              </p>
            </div>
          </div>
        </div>

        {/* Third Image Section with right-positioned text box */}
        <div className="max-w-6xl mx-auto mt-16 sm:mt-20 md:mt-24">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/new_evidence_girl.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                Geographical performance mapping<br />
                <strong className="text-[#db0058]">increases conversion by 47%</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">Utilities</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Pricing and competitiveness has a significant impact on overall conversion within the utilities sector. However, frequently geographical optimisation is not utilised. The challenge for this client was 'how can we improve performance of our outbound marketing?' And whilst we identified several solutions a simple re-prioritisation of effort had an immediate impact.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Through detailed geographical analysis we identified that 24% of our client's geographical areas yielded a 58% higher sale rate. Yet in some of these highest converting postcodes, where brand awareness and price competitiveness was strong less than 1% of households were being engaged. Using our prioritisation scoring methodology and Resident for optimal channel permissions we were able prioritise all postcodes into a performance ranking and increase prospect opportunity in top ranking postcodes.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                47% higher contact to sale ratio and increased engagement within outbound call teams due to higher return rates.
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <button
                  className="font-semibold rounded-full transition-colors duration-300 inline-flex items-center justify-center text-white py-2 px-6 text-sm min-h-[40px]"
                  type="button"
                  style={{ backgroundColor: 'rgb(219, 0, 88)' }}
                >
                  Find out more
                </button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/new_evidence_girl.webp"
              alt="Family working together"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle right */}
            <div className="absolute top-1/2 right-8 transform -translate-y-1/2 bg-white p-4 sm:p-5 md:p-6 shadow-lg w-4/5 max-w-2xl detaservinfo">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-3">
                Geographical performance mapping<br />
                <strong className="text-[#db0058]">increases conversion by 47%</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">Utilities</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Pricing and competitiveness has a significant impact on overall conversion within the utilities sector. However, frequently geographical optimisation is not utilised. The challenge for this client was 'how can we improve performance of our outbound marketing?' And whilst we identified several solutions a simple re-prioritisation of effort had an immediate impact.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Through detailed geographical analysis we identified that 24% of our client's geographical areas yielded a 58% higher sale rate. Yet in some of these highest converting postcodes, where brand awareness and price competitiveness was strong less than 1% of households were being engaged. Using our prioritisation scoring methodology and Resident for optimal channel permissions we were able prioritise all postcodes into a performance ranking and increase prospect opportunity in top ranking postcodes.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2 sm:mb-3">
                47% higher contact to sale ratio and increased engagement within outbound call teams due to higher return rates.
              </p>
            </div>
          </div>
        </div>

        {/* Fourth Image Section with left-positioned text box */}
        <div className="max-w-6xl mx-auto mt-16 sm:mt-20 md:mt-24">
          {/* Mobile Layout - Stacked */}
          <div className="block sm:hidden">
            <img
              src="/images/cartimg1.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '300px', objectFit: 'cover' }}
            />
            <div className="bg-white p-6 shadow-lg mx-4 -mt-8 relative z-10 rounded-lg">
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                Occupancy scoring reduces<br />
                <strong className="text-[#db0058]">suppression costs by 31%</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">Retail</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Many retailers suffer with a back book of lapsed consumer data which dependent on the period of lapse can have a high volume of goneaways and stale deceased individuals. We believe that it is really important to ensure data is clean and as accurate as possible but this unfortunately can come at significant cost to the retailer and in many cases can outweigh the opportunity value of re-engagement activity.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Using our Occupancy scoring which sits across our UK single view of 51m individuals we segment customer data based on the likelihood of an individual to have moved home. This reduces the potential for high mailing wastage or suppression costs by filtering out those individuals who are likely to have moved prior to running industry suppressions.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                Re-engagement activity focused on the top 5 segments of lapsed opportunity. Suppression costs reduced by 31% and higher scoring segments were diverted to email and social activity through our Resident marketing permissions
              </p>
              
              <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
                <button
                  className="font-semibold rounded-full transition-colors duration-300 inline-flex items-center justify-center text-white py-2 px-6 text-sm min-h-[40px]"
                  type="button"
                  style={{ backgroundColor: 'rgb(219, 0, 88)' }}
                >
                  Find out more
                </button>
              </Link>
            </div>
          </div>

          {/* Desktop Layout - Overlay */}
          <div className="hidden sm:block relative">
            <img
              src="/images/cartimg1.webp"
              alt="People working together with technology"
              className="w-full h-auto"
              style={{ height: '650px', objectFit: 'cover' }}
            />
            
            {/* Overlaid Content Box - positioned in middle left */}
            <div className="absolute top-1/2 left-8 transform -translate-y-1/2 bg-white p-4 sm:p-5 md:p-6 shadow-lg w-4/5 max-w-2xl">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-3">
                Occupancy scoring reduces<br />
                <strong className="text-[#db0058]">suppression costs by 31%</strong>
              </h2>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Sector</p>
              <p className="text-gray-700 text-sm mb-2">Retail</p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Objective</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Many retailers suffer with a back book of lapsed consumer data which dependent on the period of lapse can have a high volume of goneaways and stale deceased individuals. We believe that it is really important to ensure data is clean and as accurate as possible but this unfortunately can come at significant cost to the retailer and in many cases can outweigh the opportunity value of re-engagement activity.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Solution</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2">
                Using our Occupancy scoring which sits across our UK single view of 51m individuals we segment customer data based on the likelihood of an individual to have moved home. This reduces the potential for high mailing wastage or suppression costs by filtering out those individuals who are likely to have moved prior to running industry suppressions.
              </p>
              
              <p className="text-gray-700 text-sm font-bold mb-1">Result</p>
              <p className="text-gray-700 text-sm leading-relaxed mb-2 sm:mb-3">
                Re-engagement activity focused on the top 5 segments of lapsed opportunity. Suppression costs reduced by 31% and higher scoring segments were diverted to email and social activity through our Resident marketing permissions
              </p>
            </div>
          </div>
        </div>

      </div>
      
      {/* Third Section - Split layout with two different content areas */}
      <div className="w-full mt-16 sm:mt-20 md:mt-24">
        <div className="flex flex-col md:flex-row h-auto md:h-96">
          {/* Left side - Data, redefined */}
          <div className="w-full md:w-1/2 text-white p-8 md:p-12 flex flex-col justify-center" style={{ backgroundColor: '#9f1239' }}>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
              Data, redefined.
            </h3>
            
            <p className="text-sm sm:text-base leading-relaxed mb-8">
              Data is only ever data, unless it's high quality, accurate and brought to life in the right way. We work closely with our customers to deliver meaningful insight that drives performance and growth with a service that's tailored to each and every business.
            </p>
            
            <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium">
                Find out more about our approach
              </Button>
            </Link>
          </div>
          
          {/* Right side - Unlock the power of data */}
          <div className="w-full md:w-1/2 text-white p-8 md:p-12 flex flex-col justify-center" style={{ backgroundColor: '#970263' }}>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
              Unlock the power of data.
            </h3>
            
            <p className="text-sm sm:text-base leading-relaxed mb-8">
              With our market-leading data service, Resident, we're able to provide you with a single view of the UK covering 96% of all households and 52 million individuals. But it's not the volume of our data that's impressive — it's the accuracy and quality that sets it apart.
            </p>
            
            <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium">
                Find out more about Resident
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Let's Talk Section */}
      <div
        className="pt-8 sm:pt-12 lg:pt-16 pb-16 sm:pb-20 lg:pb-24 px-4 sm:px-8 md:px-16 lg:px-24"
        style={{ backgroundColor: COLORS.secondary }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            {/* Left Column - Let's talk */}
            <div className="text-white max-w-md">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold leading-tight mb-6 sm:mb-8">
                Let's <span style={{ color: '#db0058' }}>talk...</span>
              </h1>
              <div className="space-y-3 sm:space-y-4 text-base sm:text-lg">
                <p>So you're ready to get on board?</p>
                <p>
                  See how Lloyd James could help <strong>unlock the power of your data and take your business further.</strong>
                </p>
              </div>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="primary" size="medium" className="mt-6 sm:mt-8">
                  Contact us
                </Button>
              </Link>
            </div>

            {/* Right Column - Enquire now form */}
            <ContactForm
              title="Enquire now"
              webFormId="lloyd_james_evidence_form"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EvidencePeopleFirstSection;